module.exports = __webpack_public_path__ + "img/明党参.8ca6c85e.jpg";